module.exports = __webpack_public_path__ + "media/images/ok-icon-white-f731b3b608aef70d0a9eacdba679927c.png";